import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user/user.service';
import { AppearanceService } from '../../services/appearance/appearance.service';
import { ModalController } from '@ionic/angular';
import { AssetService } from 'src/app/services/asset/asset.service';
import { ClientService } from 'src/app/services/client/client.service';
import { Constants } from 'src/app/constants/constants';
import { DtRowModel } from 'src/app/models/datatable/dt_row.model';


@Component({
  selector: 'modal-new-location',
  templateUrl: './modal-new-location.component.html',
  styleUrls: ['./modal-new-location.component.scss'],
})
export class ModalNewLocationComponent implements OnInit {

  newLocation: DtRowModel;
  nameError: boolean = false;
  lineOneError: boolean = false;
  lineTwoError: boolean = false;
  cityError: boolean = false;
  postCodeError: boolean = false;
  organisationError: boolean = false;


  constructor(public appearanceService: AppearanceService,
   public userService: UserService, public modalController: ModalController,
   public assetService: AssetService, public clientService: ClientService) {

  }


  ngOnInit() 
  {
    this.newLocation = new DtRowModel();
    this.newLocation.addressName = "";
    this.newLocation.addressOne = "";
    this.newLocation.addressTwo = "";
    this.newLocation.addressCity = "";
    this.newLocation.addressPostCode = "";
    this.newLocation.organisationUid = this.clientService.getOrganisationUid();
    this.newLocation.organisationName = this.clientService.getOrganisationName();
  }


  ionViewWillEnter()
  {
    this.nameError = this.lineOneError = this.lineTwoError = this.cityError = this.postCodeError = false;
  }


  ionViewWillLeave()
  {

  }



  closeModal(returnData = null)
  {
    this.modalController.dismiss(returnData, null, 'NewLocationModal');
  }


  createNewLocation()
  {
    var errorFound = false;
    this.nameError = this.lineOneError = this.lineTwoError = this.cityError = this.postCodeError = false;

    if (this.newLocation.addressName == "")
    {
      this.nameError = true;
      errorFound = true;
    }

    if (this.newLocation.addressOne == "")
    {
      this.lineOneError = true;
      errorFound = true;
    }

    if (this.newLocation.addressTwo == "")
    {
      this.lineTwoError = true;
      errorFound = true;
    }

    if (this.newLocation.addressCity == "")
    {
      this.cityError = true;
      errorFound = true;
    }

    if (this.newLocation.addressPostCode == "")
    {
      this.postCodeError = true;
      errorFound = true;
    }

    if (errorFound)
    {
      return;
    }

    this.appearanceService.showLoading("Please wait...").then(() => {

      this.clientService.createNewLocation(this.newLocation).subscribe(response => {
    
        this.appearanceService.dismissLoading();

        if (response.Success)
        {
          var returnData = { locationCreated: true };
          this.closeModal(returnData);
          this.appearanceService.presentToast("Location added.", Constants.TOAST_SUCCESS);
        }
        else
        {
            this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
      },
      err => {

        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast(err, Constants.TOAST_ERROR);

      });
    });
  }
}
